import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00f6235a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "b-icon arrow_back" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Go back", -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

const goBack = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "back-wrapper",
    onClick: goBack
  }, _hoisted_3))
}
}

})